<template>
<v-dialog v-model="show" max-width="1300px">
  <Contacts />
  <v-card>
    <v-card-actions>
      <v-btn outlined color="primary" flat @click.stop="show=false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import Contacts from "@/views/Contacts.vue";

export default {
  components: {
    Contacts
  },  
  props: ['visible'],
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>

<style scoped>

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}

</style>